"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderWidth = exports.Button = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _excluded = ["component", "$semanticColor", "$buttonSize", "$hover", "$active", "$focus", "$isUsingKeyboard", "$useBrowserDefaultFocusStyle", "$fullWidth", "$iconLeading", "$iconTrailing", "$iconOnly"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var borderWidth = exports.borderWidth = 1;
var getBorderColors = function getBorderColors(semanticColor) {
  var borderDefaultColor;
  var borderHoverColor;
  switch (semanticColor) {
    case _index.semanticColors.textAnnouncement:
    case _index.semanticColors.textBrightAccent:
    case _index.semanticColors.textNegative:
    case _index.semanticColors.textPositive:
    case _index.semanticColors.textSubdued:
    case _index.semanticColors.textWarning:
      borderDefaultColor = borderHoverColor = semanticColor;
      break;
    default:
      // includes textBase
      borderDefaultColor = _index.semanticColors.essentialSubdued;
      borderHoverColor = _index.semanticColors.essentialBase;
      break;
  }
  return {
    borderDefaultColor: (0, _index.cssColorValue)(borderDefaultColor),
    borderHoverColor: (0, _index.cssColorValue)(borderHoverColor)
  };
};
var Button = exports.Button = (0, _styledComponents["default"])( /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$component = _ref.component,
    Component = _ref$component === void 0 ? 'button' : _ref$component,
    $semanticColor = _ref.$semanticColor,
    $buttonSize = _ref.$buttonSize,
    $hover = _ref.$hover,
    $active = _ref.$active,
    $focus = _ref.$focus,
    $isUsingKeyboard = _ref.$isUsingKeyboard,
    $useBrowserDefaultFocusStyle = _ref.$useBrowserDefaultFocusStyle,
    $fullWidth = _ref.$fullWidth,
    $iconLeading = _ref.$iconLeading,
    $iconTrailing = _ref.$iconTrailing,
    $iconOnly = _ref.$iconOnly,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Button",
  componentId: "sc-y0gtbx-0"
})(["", ""], function (_ref2) {
  var $buttonSize = _ref2.$buttonSize,
    _ref2$$semanticColor = _ref2.$semanticColor,
    $semanticColor = _ref2$$semanticColor === void 0 ? _index.semanticColors.textBase : _ref2$$semanticColor,
    $hover = _ref2.$hover,
    $active = _ref2.$active,
    $focus = _ref2.$focus,
    $useBrowserDefaultFocusStyle = _ref2.$useBrowserDefaultFocusStyle,
    $isUsingKeyboard = _ref2.$isUsingKeyboard,
    $fullWidth = _ref2.$fullWidth,
    $iconLeading = _ref2.$iconLeading,
    $iconTrailing = _ref2.$iconTrailing,
    $iconOnly = _ref2.$iconOnly;
  var _getBorderColors = getBorderColors($semanticColor),
    borderDefaultColor = _getBorderColors.borderDefaultColor,
    borderHoverColor = _getBorderColors.borderHoverColor;
  var hoverStyles = (0, _styledComponents.css)(["", " border:", "px solid ", ";", ""], !$fullWidth && _index.buttonStylesHover, borderWidth, borderHoverColor, $semanticColor === 'textSubdued' && (0, _styledComponents.css)(["color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textBase)));
  var activeStyles = (0, _styledComponents.css)(["", " border:", "px solid ", ";"], _index.buttonStylesActive, borderWidth, borderDefaultColor);
  var disabledStyles = (0, _styledComponents.css)(["", " border-color:", ";&::after{border-color:transparent;}"], _index.buttonStylesDisabled, borderDefaultColor);
  var padding = (0, _index.getButtonPadding)({
    buttonSize: $buttonSize,
    iconPlacement: (0, _index.getIconPlacement)({
      iconOnly: $iconOnly,
      iconLeading: $iconLeading,
      iconTrailing: $iconTrailing
    }),
    borderWidth: borderWidth
  });
  return (0, _styledComponents.css)(["", ";", " ", ";border:", "px solid ", ";color:", ";min-inline-size:0;min-block-size:", ";display:inline-flex;align-items:center;justify-content:center;", ";", " &:hover{", ";}", " &:active{", ";}", " &[disabled],&[aria-disabled='true'],fieldset[disabled] &{", ";}"], (0, _index.buttonStylesBase)($useBrowserDefaultFocusStyle), padding, !$useBrowserDefaultFocusStyle && (0, _index.focusGapBorder)(_index.buttonBorderRadius, $isUsingKeyboard, $focus, true), borderWidth, borderDefaultColor, (0, _index.cssColorValue)($semanticColor), (0, _index.cssControlSize)((0, _index.slControlSize)($buttonSize), _index.controlSizeFallback[$buttonSize]), (0, _index.overflowWrapFlexText)(), $fullWidth && (0, _styledComponents.css)(["inline-size:100%;"]), hoverStyles, $hover && hoverStyles, activeStyles, $active && activeStyles, disabledStyles);
});